import clsx from 'clsx'

import { Text } from '@wartek-id/text'

type TindakLanjutProps = {
  errorMessage: string
  fontSize?: 'body' | 'body-sm' | 'helper'
  isClip?: boolean
}
export function TindakLanjut({
  errorMessage,
  fontSize = 'body-sm',
  isClip = false,
}: TindakLanjutProps) {
  switch (errorMessage) {
    case 'Pegawai belum membuat SKP di PMM sampai selesai':
      return (
        <div
          className={clsx(
            'flex flex-col gap-1',
            isClip ? 'h-9 overflow-hidden text-ellipsis' : ''
          )}
        >
          <Text variant={fontSize}>
            Pegawai terkait melanjutkan proses perencanaan di PMM, memastikan
            bahwa semua rencana telah disetujui oleh atasan dan disepakati
            bersama
          </Text>
          <Text variant={fontSize}>
            Dalam waktu 1x24 jam setelah perencanaan selesai dibuat di PMM,
            pegawai dapat mencoba kembali tombol Sinkron PMM di e-Kinerja untuk
            memperbarui data dan memastikan keselarasan dengan sistem.
          </Text>
        </div>
      )
    case 'Tidak ada RHK yang terdeteksi di PMM':
      return (
        <div
          className={clsx(
            'flex flex-col gap-1',
            isClip ? 'h-9 overflow-hidden text-ellipsis' : ''
          )}
        >
          <Text variant={fontSize}>
            Pastikan SKP yang diajukan ke atasan sudah disetujui atasan dan
            disepakati
          </Text>
        </div>
      )
    case 'Data Unit Kerja Pegawai tidak terdaftar di Referensi Unit Kerja':
      return (
        <div
          className={clsx(
            'flex flex-col gap-1',
            isClip ? 'h-9 overflow-hidden text-ellipsis' : ''
          )}
        >
          <Text variant={fontSize}>
            Admin Instansi melakukan perbaikan di e-Kinerja dan SIASN.
          </Text>
          <Text variant={fontSize}>
            Admin Instansi memastikan bahwa Unit Organisasi (Unor) terkait di
            kedua sistem tersebut berstatus aktif, karena sinkronisasi PMM akan
            gagal jika salah satu di antaranya tidak aktif.
          </Text>
          <Text variant={fontSize}>
            Setelah perbaikan selesai, pegawai maupun Admin Instansi dapat
            mencoba kembali sinkronisasi PMM.
          </Text>
        </div>
      )
    case 'Data SKP Organisasi belum dibuat oleh atasan':
      return (
        <div
          className={clsx(
            'flex flex-col gap-1',
            isClip ? 'h-9 overflow-hidden text-ellipsis' : ''
          )}
        >
          <Text variant={fontSize}>
            Atasan Guru (Kepala Sekolah) atau Admin Instansi dapat memperbaiki
            di e-Kinerja dengan dua opsi berikut:
          </Text>
          <ul className="list-disc pl-4">
            <li className="mb-1">
              <Text variant={fontSize}>
                Opsi A: Kepala Sekolah melakukan sinkronisasi di e-Kinerja,
                berdasarkan informasi yang diberikan oleh guru.
              </Text>
            </li>
            <li>
              <Text variant={fontSize}>
                Opsi B: Admin Instansi melakukan sinkronisasi PMM untuk Kepala
                Sekolah terkait di e-Kinerja.
              </Text>
            </li>
          </ul>
        </div>
      )
    case 'Unit Kerja atasan tidak ditemukan':
      return (
        <div
          className={clsx(
            'flex flex-col gap-1',
            isClip ? 'h-9 overflow-hidden text-ellipsis' : ''
          )}
        >
          <Text variant={fontSize}>
            Perbaikan dilakukan oleh Admin Instansi di e-Kinerja:
          </Text>
          <ul className="list-disc pl-4">
            <li className="mb-1">
              <Text variant={fontSize}>
                Periksa Unor: Admin Instansi memastikan bahwa seluruh unit
                organisasi (Unor) sekolah di e-Kinerja memiliki unit kerja
                atasan yang sesuai melalui menu Manajemen Unor.
              </Text>
            </li>
            <li>
              <Text variant={fontSize}>
                Perbaikan Unor: Menu Manajemen Unor: Admin Instansi menggunakan
                menu Manajemen Unor untuk memeriksa dan menambahkan unit kerja
                atasan pada seluruh Unor sekolah yang tidak memilikinya.
              </Text>
            </li>
            <li>
              <Text variant={fontSize}>
                Sinkronisasi Ulang: Setelah perbaikan dilakukan, Admin Instansi
                dapat mencoba kembali proses menekan Sinkro PMM di e-Kinerja
                untuk memastikan bahwa semua data telah diperbarui dan
                tersinkronisasi dengan benar.
              </Text>
            </li>
          </ul>
        </div>
      )
    case 'Data atasan di PMM berbeda dengan e-Kinerja, data PMM':
      return (
        <div
          className={clsx(
            'flex flex-col gap-1',
            isClip ? 'h-9 overflow-hidden text-ellipsis' : ''
          )}
        >
          <Text variant={fontSize}>
            Admin Instansi melakukan perbaikan data di e-Kinerja dan SIASN
            dengan langkah-langkah berikut:
          </Text>
          <ol className="list-decimal pl-4">
            <li className="mb-1">
              <Text variant={fontSize}>
                Identifikasi Perbedaan Atasan: Admin Instansi menggunakan menu
                Log Sinkronisasi PMM di e-Kinerja untuk mengetahui perbedaan
                atasan yang terdapat di PMM.
              </Text>
            </li>
            <li>
              <Text variant={fontSize}>
                Pembaruan Data Atasan: Setelah mengetahui perbedaan atasan,
                Admin Instansi melakukan pembaruan data atasan unor di e-Kinerja
                dan SIASN sesuai dengan informasi yang ada di PMM.
              </Text>
            </li>
            <li>
              <Text variant={fontSize}>
                Sinkron PMM untuk Pegawai Terkait: Setelah dilakukan pembaruan
                data, maka Admin Instansi dapat melakukan sinkron PMM untuk
                pegawai terkait, sehingga data yang tersinkronisasi di e-Kinerja
                dan SIASN menjadi akurat.
              </Text>
            </li>
          </ol>
        </div>
      )
    case 'Tidak ada RHK atasan yang bisa dikaitkan, yaitu':
      return (
        <div
          className={clsx(
            'flex flex-col gap-1',
            isClip ? 'h-9 overflow-hidden text-ellipsis' : ''
          )}
        >
          <Text variant={fontSize}>
            Pastikan SKP yang diajukan ke atasan sudah disetujui atasan dan
            disepakati
          </Text>
        </div>
      )
    case 'Tidak ditemukan Unor di e-Kinerja':
      return (
        <div
          className={clsx(
            'flex flex-col gap-1',
            isClip ? 'h-9 overflow-hidden text-ellipsis' : ''
          )}
        >
          <Text variant={fontSize}>
            Perbaikan dilakukan oleh Admin Instansi di e-Kinerja dan SIASN.
          </Text>
          <ul className="list-disc pl-4">
            <li className="mb-1">
              <Text variant={fontSize}>
                Dalam Kondisi A: Admin Instansi dapat mengetahui perbedaan nama
                Unor yang terdapat di PMM melalui menu Log Sinkronisasi PMM di
                e-Kinerja. Admin kemudian dapat melakukan pembaruan nama Unor
                pada menu Manajemen Unor.
              </Text>
            </li>
            <li>
              <Text variant={fontSize}>
                Dalam Kondisi B: Admin Instansi dapat melakukan pembaruan Unor
                dari pegawai melalui menu Manajemen Pegawai di
                e-Kinerja.Perbaikan dilakukan oleh Operator Sekolah.
              </Text>
            </li>
            <li>
              <Text variant={fontSize}>
                Guru melaporkan perpindahan sekolah kepada Operator Sekolah
                mengenai perpindahan sekolah yang terjadi. Operator Sekolah
                kemudian dapat memperbarui data sekolah yang sesuai di Dapodik.
              </Text>
            </li>
          </ul>
        </div>
      )
    case 'Unor ID Berbeda':
      return (
        <div
          className={clsx(
            'flex flex-col gap-1',
            isClip ? 'h-9 overflow-hidden text-ellipsis' : ''
          )}
        >
          <Text variant={fontSize}>
            Perbaikan dilakukan oleh Admin Instansi di e-Kinerja dan SIASN.
          </Text>
          <ul className="list-disc pl-4">
            <li className="mb-1">
              <Text variant={fontSize}>
                Dalam Kondisi A: Admin Instansi dapat mengetahui perbedaan nama
                Unor yang terdapat di PMM melalui menu Log Sinkronisasi PMM di
                e-Kinerja. Admin kemudian dapat melakukan pembaruan nama Unor
                pada menu Manajemen Unor.
              </Text>
            </li>
            <li>
              <Text variant={fontSize}>
                Dalam Kondisi B: Admin Instansi dapat melakukan pembaruan Unor
                dari pegawai melalui menu Manajemen Pegawai di
                e-Kinerja.Perbaikan dilakukan oleh Operator Sekolah.
              </Text>
            </li>
            <li>
              <Text variant={fontSize}>
                Guru melaporkan perpindahan sekolah kepada Operator Sekolah
                mengenai perpindahan sekolah yang terjadi. Operator Sekolah
                kemudian dapat memperbarui data sekolah yang sesuai di Dapodik.
              </Text>
            </li>
          </ul>
        </div>
      )
    default:
      return <span>-</span>
  }
}
